"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: auth/auth-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fauth%2Fauth-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthServiceClient = exports.ShortTokenResponse = exports.ShortTokenRequest = exports.ExchangeTokenResponse = exports.ExchangeTokenRequest = exports.CompleteLoginResponse = exports.CompleteLoginRequest = exports.TestResponse = exports.TestRequest = exports.GetPermissionsResponse = exports.GetPermissionsRequest = exports.GetSessionResponse = exports.GetSessionRequest = exports.AliasExistsResponse = exports.AliasExistsRequest = exports.GetKeysResponse = exports.GetKeysRequest = exports.GetProfileResponse = exports.GetProfileRequest = exports.UpdateResponse = exports.UpdateRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const alias_1 = require("../common/alias");
const step_permission_1 = require("../common/step-permission");
const token_1 = require("../common/token");
const operations_1 = require("./operations");
const profile_1 = require("./profile");
const session_1 = require("./session");
const protobufPackage = 'com.step.auth.proto';
function createBaseUpdateRequest() {
    return { operations: [] };
}
exports.UpdateRequest = {
    fromJSON(object) {
        const message = {
            operations: globalThis.Array.isArray(object?.operations)
                ? object.operations.map((e) => operations_1.ProfileOperation.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.operations?.length) {
            obj.operations = message.operations.map((e) => operations_1.ProfileOperation.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.UpdateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateRequest();
        message.operations = object.operations?.map((e) => operations_1.ProfileOperation.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUpdateResponse() {
    return {};
}
exports.UpdateResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateResponse();
        return message;
    },
};
function createBaseGetProfileRequest() {
    return {};
}
exports.GetProfileRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetProfileRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetProfileRequest();
        return message;
    },
};
function createBaseGetProfileResponse() {
    return { profile: profile_1.Profile.fromPartial({}) };
}
exports.GetProfileResponse = {
    fromJSON(object) {
        const message = {
            profile: isSet(object.profile) ? profile_1.Profile.fromJSON(object.profile) : profile_1.Profile.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.profile !== undefined) {
            obj.profile = profile_1.Profile.toJSON(message.profile);
        }
        return obj;
    },
    create(base) {
        return exports.GetProfileResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetProfileResponse();
        message.profile = (object.profile !== undefined && object.profile !== null)
            ? profile_1.Profile.fromPartial(object.profile)
            : profile_1.Profile.fromPartial({});
        return message;
    },
};
function createBaseGetKeysRequest() {
    return {};
}
exports.GetKeysRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetKeysRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetKeysRequest();
        return message;
    },
};
function createBaseGetKeysResponse() {
    return { keys: [] };
}
exports.GetKeysResponse = {
    fromJSON(object) {
        const message = {
            keys: globalThis.Array.isArray(object?.keys)
                ? object.keys.map((e) => profile_1.Key.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.keys?.length) {
            obj.keys = message.keys.map((e) => profile_1.Key.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetKeysResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetKeysResponse();
        message.keys = object.keys?.map((e) => profile_1.Key.fromPartial(e)) || [];
        return message;
    },
};
function createBaseAliasExistsRequest() {
    return { alias: alias_1.Alias.fromPartial({}) };
}
exports.AliasExistsRequest = {
    fromJSON(object) {
        const message = {
            alias: isSet(object.alias) ? alias_1.Alias.fromJSON(object.alias) : alias_1.Alias.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        return obj;
    },
    create(base) {
        return exports.AliasExistsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAliasExistsRequest();
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : alias_1.Alias.fromPartial({});
        return message;
    },
};
function createBaseAliasExistsResponse() {
    return { exists: false };
}
exports.AliasExistsResponse = {
    fromJSON(object) {
        const message = {
            exists: isSet(object.exists) ? globalThis.Boolean(object.exists) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.exists !== false) {
            obj.exists = message.exists;
        }
        return obj;
    },
    create(base) {
        return exports.AliasExistsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAliasExistsResponse();
        message.exists = object.exists ?? false;
        return message;
    },
};
function createBaseGetSessionRequest() {
    return {};
}
exports.GetSessionRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetSessionRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetSessionRequest();
        return message;
    },
};
function createBaseGetSessionResponse() {
    return { session: session_1.Session.fromPartial({}) };
}
exports.GetSessionResponse = {
    fromJSON(object) {
        const message = {
            session: isSet(object.session) ? session_1.Session.fromJSON(object.session) : session_1.Session.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.session !== undefined) {
            obj.session = session_1.Session.toJSON(message.session);
        }
        return obj;
    },
    create(base) {
        return exports.GetSessionResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetSessionResponse();
        message.session = (object.session !== undefined && object.session !== null)
            ? session_1.Session.fromPartial(object.session)
            : session_1.Session.fromPartial({});
        return message;
    },
};
function createBaseGetPermissionsRequest() {
    return {};
}
exports.GetPermissionsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetPermissionsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetPermissionsRequest();
        return message;
    },
};
function createBaseGetPermissionsResponse() {
    return { permissions: [] };
}
exports.GetPermissionsResponse = {
    fromJSON(object) {
        const message = {
            permissions: globalThis.Array.isArray(object?.permissions)
                ? object.permissions.map((e) => (0, step_permission_1.stepPermissionFromJSON)(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.permissions?.length) {
            obj.permissions = message.permissions.map((e) => (0, step_permission_1.stepPermissionToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetPermissionsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPermissionsResponse();
        message.permissions = object.permissions?.map((e) => e) || [];
        return message;
    },
};
function createBaseTestRequest() {
    return { allowSuspended: false, level: 0 };
}
exports.TestRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.allowSuspended)) {
            message.allowSuspended = globalThis.Boolean(object.allowSuspended);
        }
        if (isSet(object.level)) {
            message.level = globalThis.Number(object.level);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.allowSuspended !== undefined && message.allowSuspended !== false) {
            obj.allowSuspended = message.allowSuspended;
        }
        if (message.level !== undefined && message.level !== 0) {
            obj.level = Math.round(message.level);
        }
        return obj;
    },
    create(base) {
        return exports.TestRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTestRequest();
        message.allowSuspended = object.allowSuspended ?? false;
        message.level = object.level ?? 0;
        return message;
    },
};
function createBaseTestResponse() {
    return {
        userId: '',
        level: 0,
        phoneVerified: false,
        emailVerified: false,
        suspended: false,
        lastResetAtMs: '0',
        issuedAtMs: '0',
        ttl: '0',
        clientTimeSkew: '0',
        deviceId: '',
        sessionId: '',
        audience: '',
    };
}
exports.TestResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        if (isSet(object.level)) {
            message.level = globalThis.Number(object.level);
        }
        if (isSet(object.phoneVerified)) {
            message.phoneVerified = globalThis.Boolean(object.phoneVerified);
        }
        if (isSet(object.emailVerified)) {
            message.emailVerified = globalThis.Boolean(object.emailVerified);
        }
        if (isSet(object.suspended)) {
            message.suspended = globalThis.Boolean(object.suspended);
        }
        if (isSet(object.lastResetAtMs)) {
            message.lastResetAtMs = globalThis.String(object.lastResetAtMs);
        }
        if (isSet(object.issuedAtMs)) {
            message.issuedAtMs = globalThis.String(object.issuedAtMs);
        }
        if (isSet(object.ttl)) {
            message.ttl = globalThis.String(object.ttl);
        }
        if (isSet(object.clientTimeSkew)) {
            message.clientTimeSkew = globalThis.String(object.clientTimeSkew);
        }
        if (isSet(object.deviceId)) {
            message.deviceId = globalThis.String(object.deviceId);
        }
        if (isSet(object.sessionId)) {
            message.sessionId = globalThis.String(object.sessionId);
        }
        if (isSet(object.audience)) {
            message.audience = globalThis.String(object.audience);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== undefined && message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.level !== undefined && message.level !== 0) {
            obj.level = Math.round(message.level);
        }
        if (message.phoneVerified !== undefined && message.phoneVerified !== false) {
            obj.phoneVerified = message.phoneVerified;
        }
        if (message.emailVerified !== undefined && message.emailVerified !== false) {
            obj.emailVerified = message.emailVerified;
        }
        if (message.suspended !== undefined && message.suspended !== false) {
            obj.suspended = message.suspended;
        }
        if (message.lastResetAtMs !== undefined && message.lastResetAtMs !== '0') {
            obj.lastResetAtMs = message.lastResetAtMs;
        }
        if (message.issuedAtMs !== undefined && message.issuedAtMs !== '0') {
            obj.issuedAtMs = message.issuedAtMs;
        }
        if (message.ttl !== undefined && message.ttl !== '0') {
            obj.ttl = message.ttl;
        }
        if (message.clientTimeSkew !== undefined && message.clientTimeSkew !== '0') {
            obj.clientTimeSkew = message.clientTimeSkew;
        }
        if (message.deviceId !== undefined && message.deviceId !== '') {
            obj.deviceId = message.deviceId;
        }
        if (message.sessionId !== undefined && message.sessionId !== '') {
            obj.sessionId = message.sessionId;
        }
        if (message.audience !== undefined && message.audience !== '') {
            obj.audience = message.audience;
        }
        return obj;
    },
    create(base) {
        return exports.TestResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTestResponse();
        message.userId = object.userId ?? '';
        message.level = object.level ?? 0;
        message.phoneVerified = object.phoneVerified ?? false;
        message.emailVerified = object.emailVerified ?? false;
        message.suspended = object.suspended ?? false;
        message.lastResetAtMs = object.lastResetAtMs ?? '0';
        message.issuedAtMs = object.issuedAtMs ?? '0';
        message.ttl = object.ttl ?? '0';
        message.clientTimeSkew = object.clientTimeSkew ?? '0';
        message.deviceId = object.deviceId ?? '';
        message.sessionId = object.sessionId ?? '';
        message.audience = object.audience ?? '';
        return message;
    },
};
function createBaseCompleteLoginRequest() {
    return { refreshToken: '' };
}
exports.CompleteLoginRequest = {
    fromJSON(object) {
        const message = {
            refreshToken: isSet(object.refreshToken) ? globalThis.String(object.refreshToken) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.refreshToken !== '') {
            obj.refreshToken = message.refreshToken;
        }
        return obj;
    },
    create(base) {
        return exports.CompleteLoginRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCompleteLoginRequest();
        message.refreshToken = object.refreshToken ?? '';
        return message;
    },
};
function createBaseCompleteLoginResponse() {
    return {
        userId: '',
        refreshToken: token_1.AuthToken.fromPartial({}),
        accessToken: token_1.AuthToken.fromPartial({}),
    };
}
exports.CompleteLoginResponse = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            refreshToken: isSet(object.refreshToken)
                ? token_1.AuthToken.fromJSON(object.refreshToken)
                : token_1.AuthToken.fromPartial({}),
            accessToken: isSet(object.accessToken)
                ? token_1.AuthToken.fromJSON(object.accessToken)
                : token_1.AuthToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.refreshToken !== undefined) {
            obj.refreshToken = token_1.AuthToken.toJSON(message.refreshToken);
        }
        if (message.accessToken !== undefined) {
            obj.accessToken = token_1.AuthToken.toJSON(message.accessToken);
        }
        return obj;
    },
    create(base) {
        return exports.CompleteLoginResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCompleteLoginResponse();
        message.userId = object.userId ?? '';
        message.refreshToken = (object.refreshToken !== undefined && object.refreshToken !== null)
            ? token_1.AuthToken.fromPartial(object.refreshToken)
            : token_1.AuthToken.fromPartial({});
        message.accessToken = (object.accessToken !== undefined && object.accessToken !== null)
            ? token_1.AuthToken.fromPartial(object.accessToken)
            : token_1.AuthToken.fromPartial({});
        return message;
    },
};
function createBaseExchangeTokenRequest() {
    return {};
}
exports.ExchangeTokenRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ExchangeTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseExchangeTokenRequest();
        return message;
    },
};
function createBaseExchangeTokenResponse() {
    return { exchangeToken: token_1.AuthToken.fromPartial({}) };
}
exports.ExchangeTokenResponse = {
    fromJSON(object) {
        const message = {
            exchangeToken: isSet(object.exchangeToken)
                ? token_1.AuthToken.fromJSON(object.exchangeToken)
                : token_1.AuthToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.exchangeToken !== undefined) {
            obj.exchangeToken = token_1.AuthToken.toJSON(message.exchangeToken);
        }
        return obj;
    },
    create(base) {
        return exports.ExchangeTokenResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseExchangeTokenResponse();
        message.exchangeToken = (object.exchangeToken !== undefined && object.exchangeToken !== null)
            ? token_1.AuthToken.fromPartial(object.exchangeToken)
            : token_1.AuthToken.fromPartial({});
        return message;
    },
};
function createBaseShortTokenRequest() {
    return {};
}
exports.ShortTokenRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ShortTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseShortTokenRequest();
        return message;
    },
};
function createBaseShortTokenResponse() {
    return { shortToken: token_1.AuthToken.fromPartial({}) };
}
exports.ShortTokenResponse = {
    fromJSON(object) {
        const message = {
            shortToken: isSet(object.shortToken)
                ? token_1.AuthToken.fromJSON(object.shortToken)
                : token_1.AuthToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.shortToken !== undefined) {
            obj.shortToken = token_1.AuthToken.toJSON(message.shortToken);
        }
        return obj;
    },
    create(base) {
        return exports.ShortTokenResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseShortTokenResponse();
        message.shortToken = (object.shortToken !== undefined && object.shortToken !== null)
            ? token_1.AuthToken.fromPartial(object.shortToken)
            : token_1.AuthToken.fromPartial({});
        return message;
    },
};
/**
 * Authentication Service API.
 *
 * Update and retrieve user profile data.
 */
class AuthServiceClient {
    rpc;
    name = 'com.step.auth.proto.AuthService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/auth';
    methods = [{
            name: 'Update',
            requestType: exports.UpdateRequest,
            responseType: exports.UpdateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
            adminTokenType: undefined,
        }, {
            name: 'GetProfile',
            requestType: exports.GetProfileRequest,
            responseType: exports.GetProfileResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'GetKeys',
            requestType: exports.GetKeysRequest,
            responseType: exports.GetKeysResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'AliasExists',
            requestType: exports.AliasExistsRequest,
            responseType: exports.AliasExistsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'GetSession',
            requestType: exports.GetSessionRequest,
            responseType: exports.GetSessionResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.RESTRICTED },
            adminTokenType: undefined,
        }, {
            name: 'GetPermissions',
            requestType: exports.GetPermissionsRequest,
            responseType: exports.GetPermissionsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.RESTRICTED },
            adminTokenType: undefined,
        }, {
            name: 'CompleteLogin',
            requestType: exports.CompleteLoginRequest,
            responseType: exports.CompleteLoginResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.RESTRICTED },
            adminTokenType: undefined,
        }, {
            name: 'Test',
            requestType: exports.TestRequest,
            responseType: exports.TestResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.RESTRICTED },
            adminTokenType: undefined,
        }, {
            name: 'ExchangeToken',
            requestType: exports.ExchangeTokenRequest,
            responseType: exports.ExchangeTokenResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'ShortToken',
            requestType: exports.ShortTokenRequest,
            responseType: exports.ShortTokenResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Updates security principal (user) profile.
     */
    update(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Return's principal's profile.
     */
    getProfile(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns principal's keys.
     */
    getKeys(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Checks if alias has already been registered.
     */
    aliasExists(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns the user's current login session.
     */
    getSession(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get the permissions associated with the Step group(s) of the current user.
     */
    getPermissions(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Used to complete login for completed wrong login flow session. This is
     * requested when a user chooses to continue with signing up. This will
     * verify the phone alias on the user.
     */
    completeLogin(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Used for testing. Given a token passed in in the authorization header,
     * validates it and returns the authenticated principal back.
     */
    test(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Generate an exchange token for the authenticated user.
     * Used to pass a token through intercom custom attribute with limited length.
     */
    exchangeToken(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * DEPRECATED: Use ExchangeToken instead.
     * TODO(BANK-3391): update usage in the mobile app
     * TODO(BANK-3392): remove protos once clients update
     */
    shortToken(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.AuthServiceClient = AuthServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=auth-service.js.map